export default __webpack_public_path__ + "static/media/Rabbit.730e9f3b.png";